export const getIdentifier = (item)=>{
    // if its string
    if ([
        'string',
        'number'
    ].includes(typeof item)) return item;
    else if (item) return item.id || item.key || item.title || item.name;
    return item;
};
export const getTitle = (item)=>{
    // if its string
    if ([
        'string',
        'number'
    ].includes(typeof item)) return item;
    else if (item) return item.title || item.name || item.key;
    return item;
};
